const milestones = [
  {
    year: '2007',
    title: 'Ausbildung zur ZMP',
    description: 'Mit 16 Jahren begann meine Reise in die Zahnwelt — Abschluss als Zahnmedizinische Prophylaxe-Assistentin (ZMP). Schon damals war klar: Das ist mein Weg.',
  },
  {
    year: '2007–2020',
    title: '13 Jahre in der Dentalbranche',
    description: 'Über ein Jahrzehnt intensive Erfahrung in der Dentalbranche — mit Schwerpunkt auf Beratung, Hygiene und Patientenbetreuung in renommierten Zahnarztpraxen in Köln.',
  },
  {
    year: '2020–2023',
    title: 'Digitalisierung & Innovation bei SynMedico',
    description: 'Wechsel in die Dentalbranche 2.0: Bei SynMedico arbeitete ich an der Digitalisierung von Dentalpraxen — mit modernsten Technologien und einem neuen Blick auf die Branche.',
  },
  {
    year: '2026',
    title: 'Gründung von Flow & Glow',
    description: 'Der Traum wird Wirklichkeit: Mein eigenes Studio für kosmetische Zahnaufhellung in Köln — komplett peroxidfrei, professionell und in einer Atmosphäre, in der du dich wirklich wohlfühlst.',
  },
];

export default function CareerTimeline() {
  return (
    <section className="bg-offwhite py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <span className="font-sans text-xs tracking-widest uppercase text-rose font-semibold">
            Mein Weg
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-medium text-charcoal mt-3 mb-4">
            19 Jahre Erfahrung
          </h2>
          <p className="font-sans text-base text-charcoal/60 max-w-md mx-auto leading-relaxed">
            Vom Studium bis zur eigenen Boutique — meine Geschichte ist von Leidenschaft für Lächeln geprägt.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative pl-8 md:pl-16">
          {/* Vertical line */}
          <div className="absolute left-3 md:left-7 top-2 bottom-2 w-0.5 bg-rose/30" />

          <div className="flex flex-col gap-10">
            {milestones.map((m, i) => (
              <div key={i} className="relative">
                {/* Circle on line */}
                <div className="absolute -left-8 md:-left-16 top-1.5 flex items-center justify-center">
                  <div className="w-6 h-6 rounded-full bg-rose ring-4 ring-offwhite" />
                </div>

                <div className="bg-white rounded-2xl px-6 py-6 ring-1 ring-blush">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 mb-3">
                    <span className="font-serif text-2xl font-medium text-rose">{m.year}</span>
                    <div className="hidden sm:block w-4 h-px bg-rose/30" />
                    <h3 className="font-sans text-base font-semibold text-charcoal">{m.title}</h3>
                  </div>
                  <p className="font-sans text-sm text-charcoal/65 leading-relaxed">{m.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
